<template>
  <div v-if="loading">
    <div v-if="course">
      <div class="container mb-5">
        <h1 class="mt-5 mb-5 text-center titler">{{ course.title }}</h1>
          <!-- Carousel -->
            <!-- <img class="d-block w-35" :src="course.image">
            <div class="card teacher-card">
              <div class="card-header texto">
                Insegnante: 
                {{ course.teacher.name }}
              </div>
            </div> -->
            <div class="container d-flex justify-content-center">
              <div class="card bg-dark" style="width: 18rem;">
                <img class="card-img-top" :src="course.image">
                <div class="card-body">
                  <p class="card-header card-title texto">Insegnate: {{course.teacher.name}}</p>
                </div>
              </div>
            </div>
            <p class="mt-4 textall course-description text-center" v-html="course.description"></p>
            <!-- <button v-if="user" type="button" class="btn btn-link">Modifica</button> -->
          <!-- Description -->

      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-5" v-else>
    <div class="loader"></div>
  </div>
</template>

<script>

import { database, storage } from '@/firebase'

export default {
  name: 'CourseDetail',
  data() {
    return {
      course: null,
      loading: false
    }
  },
  created() {
    database.collection('Courses')
      .doc(this.$route.params.id)
      .get().then(doc => {
        this.course = doc.data()
        storage.child("Courses/"+this.$route.params.id+"/profile").getDownloadURL().then(url => {
          this.course.image = url;
          this.course.teacher.get().then(tDoc => {
            this.course.teacher = tDoc.data()
            this.loading= true;
          })
        })
      }).then(() => {
        this.resizeImages()
      })
  },
  methods: {
    resizeImages: function() {
      let description = document.querySelector('.course-description')
      let images = description.querySelectorAll('img')

      images.forEach(image => {
        image.style.width = '100%'
      })
    }
  }
}
</script>

<style scoped>
.textall{
    color: #303030;
}

.texto {
    color: #f0932b;
}

.titler {
    color: #f0932b;
    font-weight: bold;
}

.buttora {
    color: rgb(71, 71, 71);
    background-color: #f0932b;
}

.teacher-card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.course-description > p > img {
  width: 100% !important;
}
.loader {
  border: 4px solid #f3f3f3;
  border-radius: 100%;
  border-top: 4px solid #46484c;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 0.5s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/CourseDetail.vue